module.exports = __webpack_public_path__ + "img/produto.7e9078e7.png";